import dotenv from "dotenv";

const environment = process.env.NODE_ENV || "development";

dotenv.config({ path: `.env.${environment}` });

export const reactAppAws = process.env.REACT_APP_AWS;
export const reactAppAxios = process.env.REACT_APP_AXIOS;

console.log({
    reactAppAws,
    reactAppAxios,
    environment,
});
